module.exports = __webpack_public_path__ + "img/10.cb99599e.jpg";